<template>
<div class="qcclogin">
</div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
export default {
  name: 'QccLogin',
  beforeMount () {
    this.handleToSsoLogin()
  },
  methods: {
    async handleToSsoLogin () {
      const loginid = this.$route.query.loginid
      const result = await get('/api/CBMS-APP/insideInfoCenter/getQccUrl?mobile=1', {
        loginid: loginid
      })
      const url = result.data.url_h5
      window.location.href = url
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.login
  margin : 50% auto 0
  text-align : center
  .login-btn
    padding : 16px 32px
    outline : none
    border : none
    background : #42b983
    color : #ffffff
    font-size : 32px
</style>
